import { Button } from '@/components/ui/button'
import * as Field from '@/components/ui/field'
import { Textarea } from '@/components/ui/textarea'
import { DialogContainer, OptionalField } from '@components'
import { usePotentialHighQuality, userId } from '@stateApp'
import { type Setter, Show, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { Flex, Grid } from 'styled-system/jsx'
import { useSingle } from '../../state'

export function SingalPhq(props: { isOpen: boolean; setIsOpen: Setter<boolean> }) {
  const { setupQuery, setupPotentialHigQualityQuery } =
    useService(useSingle)()
  const { createPhqMutation } = useService(usePotentialHighQuality)()
  const [message, setMessage] = createSignal('')

  const onConfirm = () => {
    const created_by = userId()
    const setup_id = setupQuery?.data?.id

    if (!created_by || !setup_id) return

    createPhqMutation.mutate(
      {
        message: message(),
        created_by,
        setup_id,
      },
      {
        onSuccess: () => {
          props.setIsOpen(false)
          setupPotentialHigQualityQuery.refetch()
        },
      }
    )
  }

  const onCancel = () => {
    props.setIsOpen(false)
  }

  return (
    <Show when={props.isOpen}>
      <DialogContainer
        title="Signal PHQ"
        description="Flag this setup as potential high quality"
        isOpen={props.isOpen}
        setIsOpen={props.setIsOpen}
      >
        <Grid gap={4}>
          <Field.Root gap={4}>
            <OptionalField>
              <Field.Label>Description</Field.Label>
            </OptionalField>
            <Textarea
              value={message()}
              onchange={({ target }: any) => setMessage(target.value)}
            />
          </Field.Root>
          <Flex gap={2}>
            <Button
              variant="solid"
              colorPalette="jade"
              onClick={onConfirm}
            >
              Confirm
            </Button>
            <Button
              loading={createPhqMutation.isPending}
              variant="outline"
              colorPalette="current"
              onClick={onCancel}
            >
              Cancel
            </Button>
          </Flex>
        </Grid>
      </DialogContainer>
    </Show>
  )
}
